export default __webpack_public_path__ + "static/media/sliderContinuous_noThemeSelected.14b24bd2.svg";